import script from "./CommunityReportManageView.vue?vue&type=script&setup=true&lang=js"
export * from "./CommunityReportManageView.vue?vue&type=script&setup=true&lang=js"

import "./CommunityReportManageView.vue?vue&type=style&index=0&id=1edc2b10&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1edc2b10"]])

export default __exports__